import React from 'react';
import PropTypes from 'prop-types';
import { InfoWindowV2 } from 'components/core/GoogleMap';
import FacilityCard from 'components/organisms/FacilityCard';

export function SearchCardInfoWindow({
	actions,
	facility,
	baseUrl,
	facilitySelected,
	handleFacilityCardVisible,
	handleFacilitySelected,
	handleFacilityDeselected,
	handlePinDeselected,
	location,
	searchType,
	searchParams,
	cloudfrontUrl,
	inMapView,
	google,
	map,
}) {
	const content = (
		<FacilityCard
			facility={facility}
			baseUrl={baseUrl}
			cloudfrontUrl={cloudfrontUrl}
			facilitySelected={facilitySelected}
			getFacilityCardPhoneNumber={() =>
				actions.getFacilityCardPhoneNumber(
					location.city,
					location.state,
					facility.id,
				)
			}
			handleFacilitySelected={handleFacilitySelected}
			handleFacilityDeselected={handleFacilityDeselected}
			handlePinDeselected={handlePinDeselected}
			miniCard
			lazyLoad={false}
			onVisible={handleFacilityCardVisible}
			storageType={searchType}
			searchParams={searchParams}
			inMapView={inMapView}
			hasOMI={facility.hasOnlineMoveins}
		/>
	);

	return (
		<InfoWindowV2
			location={facility.location}
			content={content}
			google={google}
			map={map}
		/>
	);
}

SearchCardInfoWindow.propTypes = {
	actions: PropTypes.shape({
		getFacilityCardPhoneNumber: PropTypes.func,
	}),
	facility: PropTypes.object.isRequired,
	baseUrl: PropTypes.string,
	facilitySelected: PropTypes.number,
	handleFacilityCardVisible: PropTypes.func,
	handleFacilitySelected: PropTypes.func,
	handleFacilityDeselected: PropTypes.func,
	handlePinDeselected: PropTypes.func,
	location: PropTypes.object,
	searchType: PropTypes.string,
	searchParams: PropTypes.object,
	cloudfrontUrl: PropTypes.string,
	inMapView: PropTypes.bool,
	google: PropTypes.object,
	map: PropTypes.object,
};

export default SearchCardInfoWindow;
